import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Product = apiContainer.Product
//GET--->
// Corrected getProduct function
export async function getProductApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Product}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

//CREATE---->
export async function createProduct(request) {
    try {
        return api.create(`${Product}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateProduct(request, ProductId) {
    try {
        return api.update(`${Product}/${ProductId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteProduct(ProductId) {
      try {
        return api.delete(`${Product}/${ProductId}`);
      } catch (error) {
        console.error('Fetch error:', error);
        throw error;
      }
}

